// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class ULongValue implements flatbuffers.IUnpackableObject<ULongValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ULongValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsULongValue(bb: flatbuffers.ByteBuffer, obj?: ULongValue): ULongValue {
    return (obj || new ULongValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsULongValue(bb: flatbuffers.ByteBuffer, obj?: ULongValue): ULongValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ULongValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  static startULongValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: bigint) {
    builder.addFieldInt64(0, value, 0n);
  }

  static endULongValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createULongValue(builder: flatbuffers.Builder, value: bigint): flatbuffers.Offset {
    ULongValue.startULongValue(builder);
    ULongValue.addValue(builder, value);
    return ULongValue.endULongValue(builder);
  }

  unpack(): ULongValueT {
    return new ULongValueT(this.value());
  }

  unpackTo(_o: ULongValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): ULongValueT {
    const t = new ULongValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class ULongValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: bigint = 0n) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ULongValue.createULongValue(builder, this.value);
  }

  clone(): ULongValueT {
    const obj = new ULongValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: ULongValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyULongValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
  } finally {
    verifier.popDepth();
  }
}
